var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _rect, _rect2, _rect3, _rect4, _ellipse4, _path4, _path5, _path6, _ellipse5, _path7, _path8, _path9, _path10, _rect5, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCivilStep1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 242,
    viewBox: "0 0 259 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24927 148.688L28.1371 93.375L50.0646 148.688H5.24927Z",
    stroke: "#B9D8FF",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.795 148.688L151.683 93.375L173.611 148.688H128.795Z",
    stroke: "#B9D8FF",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8423 93.1707C30.4853 92.8342 41.8708 90.7886 50.2687 85.2977C60.766 78.4341 68.4371 70.9648 89.8354 70.9648C111.234 70.9648 119.51 79.8472 129.402 85.2977C140.101 91.1931 148.243 92.4305 152.617 93.1707",
    stroke: "#B9D8FF",
    strokeWidth: 7
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.8335,
    cy: 52.3989,
    rx: 7.46923,
    ry: 7.46923,
    fill: "#B9D8FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.808,
    cy: 91.7607,
    rx: 6.45987,
    ry: 6.45987,
    fill: "#B9D8FF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.859,
    cy: 91.7607,
    rx: 6.45987,
    ry: 6.45987,
    fill: "#B9D8FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82.3643,
    y: 58.25,
    width: 14.9385,
    height: 31.8956,
    rx: 7.46923,
    fill: "#B9D8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.3643,
    y: 151.516,
    width: 14.9385,
    height: 31.8956,
    rx: 7.46923,
    fill: "#B9D8FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 139.696,
    y: 183.414,
    width: 8.47859,
    height: 100.128,
    rx: 4.2393,
    transform: "rotate(90 139.696 183.414)",
    fill: "#B9D8FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5938,
    y: 87.3203,
    width: 8.47859,
    height: 67.425,
    fill: "#B9D8FF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.8335,
    cy: 96.4106,
    rx: 7.46923,
    ry: 7.46923,
    fill: "#B9D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.611 189.867H46.229V183.609C72.0685 183.609 83.777 167.593 86.4013 159.586H92.8612C100.452 178.32 121.19 183.407 130.611 183.609V189.867Z",
    fill: "#B9D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.89988e-06 144.646C-6.35857e-06 149.893 3.04139 154.925 8.45511 158.635C13.8688 162.345 21.2114 164.43 28.8675 164.43C36.5237 164.43 43.8663 162.345 49.28 158.635C54.6937 154.925 57.7351 149.893 57.7351 144.646L28.8676 144.646L-5.89988e-06 144.646Z",
    fill: "#B9D8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.546 144.646C123.546 149.893 126.588 154.925 132.001 158.635C137.415 162.345 144.758 164.43 152.414 164.43C160.07 164.43 167.412 162.345 172.826 158.635C178.24 154.925 181.281 149.893 181.281 144.646L152.414 144.646L123.546 144.646Z",
    fill: "#B9D8FF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.224,
    cy: 122.475,
    rx: 26.9044,
    ry: 26.9044,
    fill: "#FFDCD5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.06 163.682L203.832 143.952L179.917 125.418L173.938 163.682H196.06Z",
    fill: "#FFDCD5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.253 115.321L230.734 111.734C225.951 96.7872 206.221 90.2105 190.676 100.374C178.241 108.506 178.32 122.894 179.915 129.072L197.253 115.321Z",
    fill: "#212121"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.047 165.575C133.084 158.817 139.308 154.191 146.366 154.191H228.933C239.659 154.191 247.347 164.538 244.252 174.808L227.589 230.098C225.553 236.856 219.328 241.481 212.27 241.481H129.704C118.977 241.481 111.289 231.134 114.384 220.864L131.047 165.575Z",
    fill: "#4091F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M217.701 185.234C207.369 185.234 198.569 193.281 195.46 197.304L198.329 207.954H211.243C214.113 207.954 218.418 206.534 221.288 204.404C223.584 202.7 226.071 197.541 227.027 195.174C237.072 195.174 245.681 194.464 245.681 190.914C245.681 187.364 230.615 185.234 217.701 185.234Z",
    fill: "#FFDCD5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 157.129,
    width: 101,
    height: 70,
    rx: 35,
    fill: "#003E8B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M207.069 87.2812L190.563 58.6914L223.576 58.6914L207.069 87.2812Z",
    fill: "#003E8B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M210.073 19.016L209.497 42.824H203.449L202.873 19.016H210.073ZM202.585 49.448C202.489 47.336 204.313 45.56 206.521 45.608C208.585 45.56 210.409 47.336 210.457 49.448C210.409 51.656 208.585 53.432 206.521 53.384C204.313 53.432 202.489 51.656 202.585 49.448Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCivilStep1);
export default __webpack_public_path__ + "static/media/IcCivilStep1.9bb13b2f52203ebf7aaf810f0407241c.svg";
export { ForwardRef as ReactComponent };